import { resolve } from "dns";
import { CoreApp, coreApp } from "../App/CoreApp"
import { CoreBaseApiAuthEndpoint } from "./Endpoint/CoreBaseApiAuthEndpoint";
import { CoreBaseApiStoreEndpoint } from "./Endpoint/CoreBaseApiStoreEndpoint";
import { CoreBaseApiSimulationEndpoint } from "./Endpoint/CoreBaseApiSimulationEndpoint";

export class CoreBaseApi {
    public auth: CoreBaseApiAuthEndpoint = new CoreBaseApiAuthEndpoint(this);
    public store: CoreBaseApiStoreEndpoint = new CoreBaseApiStoreEndpoint(this);
    public simulation: CoreBaseApiSimulationEndpoint = new CoreBaseApiSimulationEndpoint(this);

    public init() {
        (window as any)['core-api'] = this;
    }

    public sendBasicRequest(endPoint: string, method?: CoreApiRequestMethod, body?: any, headers?: HeadersInit, mockFunction?: () => void): Promise<CoreBaseApiBasicResult> {
        return this.sendRequest<any>(endPoint, method, body, headers, null, mockFunction);
    }

    public sendRequest<TResultType>(endPoint: string, method?: CoreApiRequestMethod, body?: any, headers?: HeadersInit, mockData?: TResultType, mockFunction?: () => void, shouldForceServer?: boolean): Promise<CoreBaseApiResult<TResultType>> {
        return coreApp.waitTilInited().then(() => {
            if(!shouldForceServer && coreApp.settings.useMockApi) {
                return new Promise<CoreBaseApiResult<TResultType>>((resolve) => {
                    this.getMockResult(mockData).then((result: CoreBaseApiResult<TResultType>) => {
                        mockFunction();
                        resolve(result);
                    });
                });
            }
            return new Promise<CoreBaseApiResult<TResultType>>((resolve) => {
                const authHeader: HeadersInit = this.auth.isLoggedIn() ? {
                    'Authorization' : 'Bearer ' + this.auth.getAuthToken()
                } : {};
                const internalHeaders: HeadersInit = {
                    ...authHeader,
                    'content-type': 'application/json'
                };
                const request = new Request(coreApp.settings.api_baseUrl + endPoint, {
                    method: method ?? CoreApiRequestMethod.GET,
                    body: body ? JSON.stringify(body) : null,
                    headers: {
                        ...headers,
                        ...internalHeaders
                    }
                })
                fetch(request).then((response) => {
                    return response.json().then((result: CoreBaseApiResult<TResultType>) => {
                        resolve(result);
                    });
                });
            });
        });
        
    }

    public getMockResult<TResult>(mockResult: TResult): Promise<CoreBaseApiResult<TResult>> {
        return new Promise<CoreBaseApiResult<TResult>>((resolve) => {
            resolve({
                data: mockResult,
                msg: '',
                succeeded: true
            });
        });
    }
}

export enum CoreApiRequestMethod {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE'
}

export interface CoreBaseApiResult<TDataType> extends CoreBaseApiBasicResult {
    data: TDataType;
}

export interface CoreBaseApiBasicResult {
    msg: string;
    succeeded: boolean;
}